export default function SelectList({ label, options, value, setValue, defaultText, inputClass, required = false }) {
    return (
        <div className="flex flex-col w-full">
            {label && (
                <label htmlFor="select" className="mb-2 text-gray-700 font-medium">
                    {label}
                </label>
            )}
            <div>
                <select
                    id="select"
                    value={value || ""}           // если value null/undefined, ставим пустое
                    onChange={(e) => setValue(e.target.value)}
                    className={`flex ${inputClass} w-full`}
                    required={required}           // required на select
                >
                    <option value="">{defaultText}</option>  {/* пустой вариант для required */}
                    {options.map((opt, index) => (
                        <option key={index} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )
}
